import {REMOVER_FILTRO_CUPOM} from '../types'

export default function removerFiltroCupom (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_CUPOM
  }
}
